import React from 'react';
import { string, shape } from 'prop-types';

const ProductsTableHead = ({ localization }) => {
    const { nameColTitle, groupColTitle, descriptionColTitle } =
        localization || {};

    return (
        <thead>
            <tr>
                <th className="products-table__name">{nameColTitle}</th>
                <th className="products-table__group">{groupColTitle}</th>
                <th>{descriptionColTitle}</th>
            </tr>
        </thead>
    );
};

ProductsTableHead.propTypes = {
    localization: shape({
        nameColTitle: string,
        groupColTitle: string,
        descriptionColTitle: string
    }).isRequired
};

export default ProductsTableHead;
